import React from 'react';
import { Star, Plus } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { useToast } from '../hooks/use-toast';

const ProductCard = ({ product }) => {
  const { addItem } = useCart();
  const { toast } = useToast();

  const handleAdd = (e) => {
    e.preventDefault();
    addItem(product);
    toast({ title: 'Added to cart', description: product.name });
  };

  return (
    <div className="group bg-white rounded-lg border border-gray-100 overflow-hidden hover-lift flex flex-col">
      <div className="relative aspect-square bg-[#f4f6fa] overflow-hidden">
        <img src={product.image} alt={product.name} className="w-full h-full object-contain p-6 transition-transform duration-500 group-hover:scale-105" />
        {product.badge && (
          <span className={`absolute top-3 left-3 text-[10px] font-bold uppercase tracking-wide px-2.5 py-1 rounded font-cond ${product.badge === 'Sale' ? 'bg-[#c8102e] text-white' : product.badge === 'New' ? 'bg-[#15a34a] text-white' : 'bg-[#141414] text-white'}`}>
            {product.badge}
          </span>
        )}
        <button onClick={handleAdd} className="absolute bottom-3 right-3 w-11 h-11 bg-[#15a34a] text-white rounded-full flex items-center justify-center shadow-lg translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300 hover:bg-[#108040]" aria-label="Add to cart">
          <Plus size={20} />
        </button>
      </div>
      <div className="p-4 flex flex-col flex-1">
        <span className="text-[11px] uppercase tracking-wide text-gray-400 font-cond">{product.subcategory}</span>
        <h3 className="font-cond font-semibold text-[#141414] leading-tight mt-1 mb-2 flex-1">{product.name}</h3>
        <div className="flex items-center gap-1 mb-2">
          {[...Array(5)].map((_, i) => (
            <Star key={i} size={13} className={i < Math.round(product.rating) ? 'fill-[#f5a623] text-[#f5a623]' : 'text-gray-200'} />
          ))}
          <span className="text-xs text-gray-400 ml-1">({product.reviews})</span>
        </div>
        <div className="flex items-center gap-2">
          <span className="font-head text-xl text-[#141414]">${product.price.toFixed(2)}</span>
          {product.oldPrice && <span className="text-sm text-gray-400 line-through">${product.oldPrice.toFixed(2)}</span>}
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
